import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-12 bg-background-50">
      <div className="container-main">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            爆料分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            选择你感兴趣的领域，获取独家内幕
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat, idx) => {
            const colorClasses: Record<string, { bg: string; text: string; hover: string; icon: string }> = {
              primary: {
                bg: 'bg-primary-50',
                text: 'text-primary-700',
                hover: 'hover:bg-primary-100/80',
                icon: 'text-primary-500',
              },
              accent: {
                bg: 'bg-accent-50',
                text: 'text-accent-700',
                hover: 'hover:bg-accent-100/80',
                icon: 'text-accent-500',
              },
              secondary: {
                bg: 'bg-secondary-50',
                text: 'text-secondary-700',
                hover: 'hover:bg-secondary-100/80',
                icon: 'text-secondary-500',
              },
            };
            const c = colorClasses[cat.color] || colorClasses.primary;

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center gap-3 p-6 rounded-lg ${c.bg} ${c.hover} transition-all duration-300 animate-fade-in-up`}
                style={{ animationDelay: `${idx * 80}ms` }}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${c.bg}`}>
                  <i className={`${cat.icon} text-2xl ${c.icon}`}></i>
                </div>
                <span className={`text-sm font-semibold ${c.text}`}>
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-400">
                  {cat.count} 篇爆料
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}